<template>
  <nav class="pagination">
    <ul v-if="displayPages.length > 0" class="pageList">
      <li v-for="(button, index) in paginationButton" :key="index" :class="{ pageInfo: button.isPaginationSummary }">
        <span v-if="button.isPaginationSummary">{{ button.description }}</span>
        <button v-else :class="{ ...button.defaultClass }" class="pageList-item" @click="paginationHandler(index)">
          <span v-if="button.isVisible" class="pageList-item-arrow"><icon :fas="button.iconFas" /></span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { PAGING_TYPE_PATH, getPageLink } from '@/utils/paging'
import PageDetector from '@/utils/PageDetector'
export default {
  props: {
    currentPage: { type: Number, default: null, required: true },
    lastPage: { type: Number, default: null, required: true },
    pagingType: { type: String, default: PAGING_TYPE_PATH, required: false }
  },
  computed: {
    pageDetector() {
      return new PageDetector(this.$route)
    },
    pageRange() {
      return { from: 1, to: this.lastPage }
    },
    displayPages() {
      const pages = []
      for (let i = this.pageRange.from; i <= this.pageRange.to; i++) pages.push(i)
      return pages.length <= 1 ? [] : pages
    },
    showNextPageNav() {
      return this.currentPage < this.lastPage
    },
    showPreviousPageNav() {
      return this.currentPage > 1
    },
    paginationButton() {
      return [
        {
          defaultClass: { prev: this.showPreviousPageNav },
          isVisible: this.showPreviousPageNav,
          destinationPage: 1,
          iconFas: 'fa-angle-double-left'
        },
        {
          defaultClass: { prev: this.showPreviousPageNav },
          isVisible: this.showPreviousPageNav,
          destinationPage: this.currentPage - 1,
          iconFas: 'fa-angle-left'
        },
        { isPaginationSummary: true, description: `${this.currentPage}/${this.displayPages.length}` },
        {
          defaultClass: { next: this.showNextPageNav },
          isVisible: this.showNextPageNav,
          destinationPage: this.currentPage + 1,
          iconFas: 'fa-angle-right'
        },
        {
          defaultClass: { next: this.showNextPageNav },
          isVisible: this.showNextPageNav,
          destinationPage: this.lastPage,
          iconFas: 'fa-angle-double-right'
        }
      ]
    }
  },
  methods: {
    paginationHandler(index) {
      this.navigateToPage(this.paginationButton[index].destinationPage)
    },
    navigateToPage(page) {
      this.$router.push(getPageLink(useRoute(), page, this.pagingType))
    }
  }
}
</script>

<style lang="scss" scoped>
.pageInfo {
  text-align: center;
  flex: 1;
}

.pageList {
  @include flex;
  max-width: 32rem;
  margin: auto;
  border: 0.1rem solid $gray-d8;
  border-radius: 0.3rem;
  background-color: $white;
  &-item {
    height: 3.5rem;
    min-width: 3.5rem;
    border: none;
    background: none;
    &.prev {
      border-right: 0.1rem solid $gray-d8;
    }
    &.next {
      border-left: 0.1rem solid $gray-d8;
    }
    &-arrow {
      @include flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 0.5em;
      color: $cerulean-blue;
      font-weight: bold;
      &:active {
        color: $white;
      }
    }
    &:active {
      background-color: $cerulean-blue;
    }
  }
}
</style>
